import useImageExists from "hooks/useImageExists/useImageExists";
import { SizedImage } from "services/motorpoint/shortlist";

export const getComingSoonVehicleSizedImages = (folderPath: string): SizedImage[] => {
    const manufacturerComingSoonImageUrl = `https://assets.motorpoint.co.uk/vehicle-advert/${folderPath}/1024.jpg`;

    const imageExists = useImageExists(manufacturerComingSoonImageUrl);

    if (imageExists) {
        return getComingSoonVehicleSizedImagesByManufacturer(folderPath);
    }

    return getComingSoonVehicleSizedImagesByManufacturer("coming-soon/default");
};

const getComingSoonVehicleSizedImagesByManufacturer = (folderPath: string): SizedImage[] => {
    return [
        {
            Format: "webp",
            Size: "Large",
            Uri: `https://assets.motorpoint.co.uk/vehicle-advert/${folderPath}/1024.webp`,
        },
        {
            Format: "webp",
            Size: "Medium",
            Uri: `https://assets.motorpoint.co.uk/vehicle-advert/${folderPath}/727.webp`,
        },
        {
            Format: "webp",
            Size: "Small",
            Uri: `https://assets.motorpoint.co.uk/vehicle-advert/${folderPath}/460.webp`,
        },
        {
            Format: "webp",
            Size: "ExtraSmall",
            Uri: `https://assets.motorpoint.co.uk/vehicle-advert/${folderPath}/333.webp`,
        },
        {
            Format: "jpeg",
            Size: "Large",
            Uri: `https://assets.motorpoint.co.uk/vehicle-advert/${folderPath}/1024.jpg`,
        },
        {
            Format: "jpeg",
            Size: "Medium",
            Uri: `https://assets.motorpoint.co.uk/vehicle-advert/${folderPath}/727.jpg`,
        },
        {
            Format: "jpeg",
            Size: "Small",
            Uri: `https://assets.motorpoint.co.uk/vehicle-advert/${folderPath}/460.jpg`,
        },
        {
            Format: "jpeg",
            Size: "ExtraSmall",
            Uri: `https://assets.motorpoint.co.uk/vehicle-advert/${folderPath}/333.jpg`,
        },
    ];
};

export default getComingSoonVehicleSizedImages;
